angular
    .module('app.controllers')
    .controller('ProfileCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, $timeout, notify, api, formValidator, $localStorage, UserService) {
        $scope.statusOptions = [
            { value: 'user_active', label: $translate.instant('user_active') },
            { value: 'user_inactive', label: $translate.instant('user_inactive') },
            { value: 'user_deleted', label: $translate.instant('user_deleted') },
            { value: 'user_suspended', label: $translate.instant('user_suspended') },
        ];

        $scope.jobOptions = [];
        api('dictionaries/jobs')
            .selectize()
            .then((response) => {
                $scope.jobOptions = response.data;
            });

        // dane użytkowników
        $scope.user = {};
        const UserModel = api('users');
        const info = notify.info($translate.instant('loading'));
        UserModel.get(UserService.getUser().id).then((response) => {
            $scope.user = response;
            if ('object' !== typeof $scope.user.settings) {
                $scope.user.settings = {};
            }

            angular.extend($scope.user.settings, UserService.getUser().settings || {});

            $timeout(() => {
                info.close();
                notify.success($translate.instant('loaded'));
                $rootScope.$broadcast('edit-panel-ready');
                $scope.setupPhotoUploader();
            });
        });

        const fv = formValidator('#ProfileForm', $scope);

        $scope.saveProfile = () => {
            if (!fv.isValid()) {
                return;
            }

            const info = notify.info($translate.instant('saving'));
            notify.global(1);

            UserModel.save($scope.user.id, $scope.user).then((response) => {
                $scope.user = response;
                // aktualizacja danych profilu
                UserService.setUser(response);
                UserModel.clearCache();

                info.close();
                notify.success($translate.instant('saved'));
                notify.global(0);

                $rootScope.$broadcast('edit-panel-ready');
            });
        };

        $scope.changePassword = () => {
            if ($scope.password.one.length < 8) {
                notify.warning($translate.instant('users.password_too_easy'));
                return false;
            } else if ($scope.password.one !== $scope.password.two) {
                notify.warning($translate.instant('users.password_doesnt_match'));
                return false;
            }

            const info = notify.info($translate.instant('saving'));
            notify.global(1);

            UserModel.post({ id: $scope.user.id, password: $scope.password.one }, { pathSuffix: '/password' }).then((response) => {
                info.close();
                if (response.result) {
                    notify.success($translate.instant('users.password_changed'));
                } else {
                    notify.warning($translate.instant('request_error'));
                }
                notify.global(0);
            });
        };

        $scope.setupPhotoUploader = () => {
            $scope.photoChanged = 0;

            const settings = {
                action: '/api/1/users/$/photo'.replace('$', $scope.user.id),
                allow: '*.(jpg|jpeg|gif|png)',
                filelimit: 1,
                param: 'photo',
                single: true,
                loadstart() {
                    notify.global(1);
                },
                progress(percent) {},
                allcomplete() {
                    notify.global(0);
                    $scope.photoChanged++;
                    $scope.user.photo = true;
                },
            };
            UIkit.uploadSelect($('#user_edit_avatar_control'), settings);
        };

        $scope.removePhoto = () => {
            notify.global(1);

            UserModel.post({}, { pathSuffix: '/$/photo'.replace('$', $scope.user.id) }).then(() => {
                notify.global(0);
                $scope.photoChanged++;
                $scope.user.photo = 0;
            });
        };

        // ustawienia
        $scope.themes = ['app_theme', 'app_theme_a', 'app_theme_b', 'app_theme_c', 'app_theme_d', 'app_theme_e', 'app_theme_f', 'app_theme_g'];

        $scope.changeTheme = ($event, theme) => {
            $event.preventDefault();
            const $this = $($event.currentTarget);

            $this.addClass('active_theme').siblings().removeClass('active_theme');

            $scope.user.settings.theme = theme.class;

            $timeout(() => {
                UserService.setupUser($scope.user.settings);
            });
        };

        $scope.$watch(
            () => angular.toJson($scope.user.settings),
            () => {
                $timeout(() => {
                    UserService.setupUser($scope.user.settings);
                });
            }
        );
    });
